export default __webpack_public_path__ + "static/media/sumz.240ade7f.png";